import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-modal-doc-info',
  templateUrl: './modal-doc-info.component.html',
  styleUrl: './modal-doc-info.component.scss'
})
export class ModalDocInfoComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Output() isVisibleChange = new EventEmitter<boolean>();

  ngOnInit(): void {
    const hasSeenModal = localStorage.getItem('hasSeenDocInfoModal');
    if (hasSeenModal) {
      this.isVisible = false;
      this.isVisibleChange.emit(this.isVisible);
    }
  }

  handleContinue() {
    localStorage.setItem('hasSeenDocInfoModal', 'true');
    this.isVisible = false;
    this.isVisibleChange.emit(this.isVisible);
  }
}
